export default __webpack_public_path__ + "static/media/Bracers of Violent Rage.bf60cfec.jpg";